import { Link } from 'react-router-dom';
import { isRouteAllowed, TIERS, DEFAULT_TIER } from '../config/tiers';

const TierGate = ({ tier, path, children }) => {
  if (isRouteAllowed(tier, path)) return children;

  const tierConfig = TIERS[tier] || TIERS[DEFAULT_TIER];
  return (
    <div className="page-container">
      <div className="empty-state" style={{ padding: '40px 24px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '8px', color: 'var(--text-primary)' }}>
          Upgrade Required
        </h2>
        <p className="empty-state-text" style={{ marginBottom: '16px' }}>
          This feature isn't available on the <strong>{tierConfig.name}</strong> plan.
          Upgrade your plan to unlock it.
        </p>
        <Link to="/upgrade" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          View Plans
        </Link>
      </div>
    </div>
  );
};

export default TierGate;
